import { Link } from "@quintype/components";
import React from "react";

import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

const DownloadLinks = () => (
  <>
    <Link
      href="https://apps.apple.com/us/app/bdnews24/id560835088"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="app-store-logo"
    >
      <SvgIconHandler className="app-store-logo" type="appstore" width="96" height="32" viewBox="0 0 96 32" />
    </Link>
    <Link
      href="https://play.google.com/store/apps/details?id=com.bdnews24.app&hl=en"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="google-play-logo"
    >
      <SvgIconHandler className="google-play-logo" type="googleplay" width="108" height="32" viewBox="0 0 108 32" />
    </Link>
  </>
);

export default DownloadLinks;
